import { createContext, useContext } from "react";

export const DRAWER_WIDTH = 280;

/** The width of the sidebar collapsed to its icon rail (R-2295). */
export const RAIL_WIDTH = 72;

/** The widest the page content column grows, beside the drawer. */
export const PAGE_MAX_WIDTH = 1360;

type DrawerType = {
  open: boolean;
  drawerWidth: number;
};

export const DrawerContext = createContext<DrawerType>({
  open: false,
  drawerWidth: DRAWER_WIDTH,
});

export function useDrawerContext() {
  return useContext(DrawerContext);
}
